//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    viewAngle: { type: Number, default: 1 },
    sku: { type: String, required: true },
    secondarySku: { type: String, default: null },
    showIrisPreview: { type: Boolean, default: false },
    ckDemoMode: { type: Boolean, default: false },
    invert: { type: Boolean, default: false },
    leMode: { type: Boolean, default: false },
    squareImage: { type: Boolean, default: false }
  },
  computed: {
    skuPrefix () { return this.sku.split('-')[0] },
    pageMode () { return this.$store.getters['product/pageMode'](this.skuPrefix) },
    baseSku () { return this.$store.getters['product/baseSKU'](this.skuPrefix) },
    swappableParts () { return this.$store.getters['product/swappableParts'](this.baseSku) },
    alternatePart () {
      if (!this.swappableParts) return null
      return this.swappableParts.find(part => !(part in this.designDetails))
    },
    spacer () { return this.$store.getters['product/spacer'](this.skuPrefix) },
    frameType () {
      let frameType = this.$store.getters['product/frameType'](this.sku)
      if (this.invert) frameType = frameType === 'ff' ? 'tf' : 'ff'
      return frameType
    },
    designDetails () { return this.$store.getters['product/detailsForSku'](this.sku) },
    secondaryDesignDetails () {
      if (!this.secondarySku) return {}
      return this.$store.getters['product/detailsForSku'](this.secondarySku)
    },
    spacerImgSrc () {
      let img = this.spacer.img
      if (['lenses', 'conversionkit'].includes(this.pageMode)) {
        img = this.spacer.img.replace(/^1-/, `${this.viewAngle}-`)
      }
      return img
    },
    layers () {
      return Object.values({ ...this.designDetails, ...this.secondaryDesignDetails }).sort(
        (a, b) => a.layer - b.layer
      ).map(
        (layer) => {
          const [part, option] = layer.sku.split('_')
          let suffix = ''
          if (this.frameType !== null && ['vcle', 'vele'].includes(part)) suffix = `-${this.frameType}`
          if (this.frameType !== null && ['ale'].includes(part)) suffix = `-${this.frameType === 'bf' ? 'ff' : 'tf'}`

          let layers = [{ part, option, suffix, isSecondary: this.isSecondary(layer.sku) }]

          if (option.startsWith('8IR')) layers = [
            { part, option, suffix: `${suffix}-B`, iris: true },
            ...layers
          ]

          return layers
        }
      ).flat()
    }
  },
  methods: {
    isSecondary (skuPart) {
      let isSecondary = skuPart in this.secondaryDesignDetails
      if (this.invert && this.swappableParts.includes(skuPart.split('_')[0])) isSecondary = !isSecondary
      return isSecondary
    },
    getSrc (layer, viewAngle) {
      if (this.leMode) return `/sungod18/limited-edition/${viewAngle}-${this.sku}.png`
      else return `/sungod18/designer/${viewAngle}-${layer.part}_${layer.option}${layer.suffix}.png`
    }
  }
}
